import {
  ISMT_ChuDe,
  ISMT_ChuDe_Vm,
} from "../../../model/respone/category/ISMT_ChuDe";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";

export const eChuDeActionsObj = {
  LOAD_START: 0,
  LOAD_SUCCESS: {} as ISMT_ChuDe_Vm[],
  LOAD_ERRR: "",

  SAVE_START: {} as ISMT_ChuDe,
  SAVE_SUCCESS: {} as ISMT_ChuDe_Vm,
  SAVE_ERROR: "",

  DELETE_START: 0,
  DELETE_SUCCESS: undefined,
  DELETE_ERROR: "",

  SHOW_EDIT_MODAL: {} as undefined | ISMT_ChuDe,
  CLOSE_EDIT_MODAL: undefined,

  SELECTED_ID: [] as number[],

  IMPORT_OPEN_MODAL: undefined,
  IMPORT_CLOSE_MODAL: undefined,
  IMPORT_START: {} as FormData,
  IMPORT_SUCCESS: "",
  IMPORT_ERROR: "",
};
export const eChuDeActionIds = generateActionTypeIds(
  eChuDeActionsObj,
  "CHU_DE"
);
export type IChuDeActionTypes = IGenericActionType<
  typeof eChuDeActionsObj,
  "CHU_DE"
>;
